// extracted by mini-css-extract-plugin
module.exports = {"title":"RegisterForMixAndMatchModal_title__3zpOG","regTitle":"RegisterForMixAndMatchModal_regTitle__2IcWc","regBtn":"RegisterForMixAndMatchModal_regBtn__1-l9K"};